export var COUNTRIES;
(function (COUNTRIES) {
    COUNTRIES["AD"] = "Andorra";
    COUNTRIES["AE"] = "United Arab Emirates";
    COUNTRIES["AF"] = "Afghanistan";
    COUNTRIES["AG"] = "Antigua And Barbuda";
    COUNTRIES["AI"] = "Anguilla";
    COUNTRIES["AL"] = "Albania";
    COUNTRIES["AM"] = "Armenia";
    COUNTRIES["AO"] = "Angola";
    COUNTRIES["AQ"] = "Antarctica";
    COUNTRIES["AR"] = "Argentina";
    COUNTRIES["AS"] = "American Samoa";
    COUNTRIES["AT"] = "Austria";
    COUNTRIES["AU"] = "Australia";
    COUNTRIES["AW"] = "Aruba";
    COUNTRIES["AX"] = "Aland Islands";
    COUNTRIES["AZ"] = "Azerbaijan";
    COUNTRIES["BA"] = "Bosnia And Herzegovina";
    COUNTRIES["BB"] = "Barbados";
    COUNTRIES["BD"] = "Bangladesh";
    COUNTRIES["BE"] = "Belgium";
    COUNTRIES["BF"] = "Burkina Faso";
    COUNTRIES["BG"] = "Bulgaria";
    COUNTRIES["BH"] = "Bahrain";
    COUNTRIES["BI"] = "Burundi";
    COUNTRIES["BJ"] = "Benin";
    COUNTRIES["BL"] = "Saint Barthelemy";
    COUNTRIES["BM"] = "Bermuda";
    COUNTRIES["BN"] = "Brunei Darussalam";
    COUNTRIES["BO"] = "Bolivia";
    COUNTRIES["BQ"] = "Bonaire Sint Eustatius Saba";
    COUNTRIES["BR"] = "Brazil";
    COUNTRIES["BS"] = "Bahamas";
    COUNTRIES["BT"] = "Bhutan";
    COUNTRIES["BV"] = "Bouvet Island";
    COUNTRIES["BW"] = "Botswana";
    COUNTRIES["BY"] = "Belarus";
    COUNTRIES["BZ"] = "Belize";
    COUNTRIES["CA"] = "Canada";
    COUNTRIES["CC"] = "Cocos Keeling Islands";
    COUNTRIES["CD"] = "Congo Democratic Republic";
    COUNTRIES["CF"] = "Central African Republic";
    COUNTRIES["CG"] = "Congo";
    COUNTRIES["CH"] = "Switzerland";
    COUNTRIES["CI"] = "Cote D'Ivoire";
    COUNTRIES["CK"] = "Cook Islands";
    COUNTRIES["CL"] = "Chile";
    COUNTRIES["CM"] = "Cameroon";
    COUNTRIES["CN"] = "China";
    COUNTRIES["CO"] = "Colombia";
    COUNTRIES["CR"] = "Costa Rica";
    COUNTRIES["CU"] = "Cuba";
    COUNTRIES["CV"] = "Cape Verde";
    COUNTRIES["CW"] = "Curacao";
    COUNTRIES["CX"] = "Christmas Island";
    COUNTRIES["CY"] = "Cyprus";
    COUNTRIES["CZ"] = "Czech Republic";
    COUNTRIES["DE"] = "Germany";
    COUNTRIES["DJ"] = "Djibouti";
    COUNTRIES["DK"] = "Denmark";
    COUNTRIES["DM"] = "Dominica";
    COUNTRIES["DO"] = "Dominican Republic";
    COUNTRIES["DZ"] = "Algeria";
    COUNTRIES["EC"] = "Ecuador";
    COUNTRIES["EE"] = "Estonia";
    COUNTRIES["EG"] = "Egypt";
    COUNTRIES["EH"] = "Western Sahara";
    COUNTRIES["ER"] = "Eritrea";
    COUNTRIES["ES"] = "Spain";
    COUNTRIES["ET"] = "Ethiopia";
    COUNTRIES["FI"] = "Finland";
    COUNTRIES["FJ"] = "Fiji";
    COUNTRIES["FK"] = "Falkland Islands";
    COUNTRIES["FM"] = "Micronesia";
    COUNTRIES["FO"] = "Faroe Islands";
    COUNTRIES["FR"] = "France";
    COUNTRIES["GA"] = "Gabon";
    COUNTRIES["GB"] = "United Kingdom";
    COUNTRIES["GD"] = "Grenada";
    COUNTRIES["GE"] = "Georgia";
    COUNTRIES["GF"] = "French Guiana";
    COUNTRIES["GG"] = "Guernsey";
    COUNTRIES["GH"] = "Ghana";
    COUNTRIES["GI"] = "Gibraltar";
    COUNTRIES["GL"] = "Greenland";
    COUNTRIES["GM"] = "Gambia";
    COUNTRIES["GN"] = "Guinea";
    COUNTRIES["GP"] = "Guadeloupe";
    COUNTRIES["GQ"] = "Equatorial Guinea";
    COUNTRIES["GR"] = "Greece";
    COUNTRIES["GS"] = "South Georgia And Sandwich Isl";
    COUNTRIES["GT"] = "Guatemala";
    COUNTRIES["GU"] = "Guam";
    COUNTRIES["GW"] = "Guinea Bissau";
    COUNTRIES["GY"] = "Guyana";
    COUNTRIES["HK"] = "HongKong";
    COUNTRIES["HM"] = "Heard Island and Mcdonald Islands";
    COUNTRIES["HN"] = "Honduras";
    COUNTRIES["HR"] = "Croatia";
    COUNTRIES["HT"] = "Haiti";
    COUNTRIES["HU"] = "Hungary";
    COUNTRIES["ID"] = "Indonesia";
    COUNTRIES["IE"] = "Ireland";
    COUNTRIES["IL"] = "Israel";
    COUNTRIES["IM"] = "Isle Of Man";
    COUNTRIES["IN"] = "India";
    COUNTRIES["IO"] = "British Indian Ocean Territory";
    COUNTRIES["IQ"] = "Iraq";
    COUNTRIES["IR"] = "Iran";
    COUNTRIES["IS"] = "Iceland";
    COUNTRIES["IT"] = "Italy";
    COUNTRIES["JE"] = "Jersey";
    COUNTRIES["JM"] = "Jamaica";
    COUNTRIES["JO"] = "Jordan";
    COUNTRIES["JP"] = "Japan";
    COUNTRIES["KE"] = "Kenya";
    COUNTRIES["KG"] = "Kyrgyzstan";
    COUNTRIES["KH"] = "Cambodia";
    COUNTRIES["KI"] = "Kiribati";
    COUNTRIES["KM"] = "Comoros";
    COUNTRIES["KN"] = "Saint Kitts And Nevis";
    COUNTRIES["KP"] = "Korea Democratic Peoples Republic";
    COUNTRIES["KR"] = "Korea";
    COUNTRIES["KW"] = "Kuwait";
    COUNTRIES["KY"] = "Cayman Islands";
    COUNTRIES["KZ"] = "Kazakhstan";
    COUNTRIES["LA"] = "Lao People's Democratic Republic";
    COUNTRIES["LB"] = "Lebanon";
    COUNTRIES["LC"] = "SaintLucia";
    COUNTRIES["LI"] = "Liechtenstein";
    COUNTRIES["LK"] = "SriLanka";
    COUNTRIES["LR"] = "Liberia";
    COUNTRIES["LS"] = "Lesotho";
    COUNTRIES["LT"] = "Lithuania";
    COUNTRIES["LU"] = "Luxembourg";
    COUNTRIES["LV"] = "Latvia";
    COUNTRIES["LY"] = "Libyan Arab Jamahiriya";
    COUNTRIES["MA"] = "Morocco";
    COUNTRIES["MC"] = "Monaco";
    COUNTRIES["MD"] = "Moldova";
    COUNTRIES["ME"] = "Montenegro";
    COUNTRIES["MF"] = "Saint Martin";
    COUNTRIES["MG"] = "Madagascar";
    COUNTRIES["MH"] = "Marshall Islands";
    COUNTRIES["MK"] = "Macedonia";
    COUNTRIES["ML"] = "Mali";
    COUNTRIES["MM"] = "Myanmar";
    COUNTRIES["MN"] = "Mongolia";
    COUNTRIES["MO"] = "Macao";
    COUNTRIES["MP"] = "Northern Mariana Islands";
    COUNTRIES["MQ"] = "Martinique";
    COUNTRIES["MR"] = "Mauritania";
    COUNTRIES["MS"] = "Montserrat";
    COUNTRIES["MT"] = "Malta";
    COUNTRIES["MU"] = "Mauritius";
    COUNTRIES["MV"] = "Maldives";
    COUNTRIES["MW"] = "Malawi";
    COUNTRIES["MX"] = "Mexico";
    COUNTRIES["MY"] = "Malaysia";
    COUNTRIES["MZ"] = "Mozambique";
    COUNTRIES["NA"] = "Namibia";
    COUNTRIES["NC"] = "New Caledonia";
    COUNTRIES["NE"] = "Niger";
    COUNTRIES["NF"] = "Norfolk Island";
    COUNTRIES["NG"] = "Nigeria";
    COUNTRIES["NI"] = "Nicaragua";
    COUNTRIES["NL"] = "Netherlands";
    COUNTRIES["NO"] = "Norway";
    COUNTRIES["NP"] = "Nepal";
    COUNTRIES["NR"] = "Nauru";
    COUNTRIES["NU"] = "Niue";
    COUNTRIES["NZ"] = "New Zealand";
    COUNTRIES["OM"] = "Oman";
    COUNTRIES["PA"] = "Panama";
    COUNTRIES["PE"] = "Peru";
    COUNTRIES["PF"] = "French Polynesia";
    COUNTRIES["PG"] = "Papua New Guinea";
    COUNTRIES["PH"] = "Philippines";
    COUNTRIES["PK"] = "Pakistan";
    COUNTRIES["PL"] = "Poland";
    COUNTRIES["PM"] = "Saint Pierre and Miquelon";
    COUNTRIES["PN"] = "Pitcairn";
    COUNTRIES["PR"] = "PuertoRico";
    COUNTRIES["PS"] = "Palestinian Territory";
    COUNTRIES["PT"] = "Portugal";
    COUNTRIES["PW"] = "Palau";
    COUNTRIES["PY"] = "Paraguay";
    COUNTRIES["QA"] = "Qatar";
    COUNTRIES["RE"] = "Reunion";
    COUNTRIES["RO"] = "Romania";
    COUNTRIES["RS"] = "Serbia";
    COUNTRIES["RU"] = "Russian Federation";
    COUNTRIES["RW"] = "Rwanda";
    COUNTRIES["SA"] = "Saudi Arabia";
    COUNTRIES["SB"] = "Solomon Islands";
    COUNTRIES["SC"] = "Seychelles";
    COUNTRIES["SD"] = "Sudan";
    COUNTRIES["SE"] = "Sweden";
    COUNTRIES["SG"] = "Singapore";
    COUNTRIES["SH"] = "SaintHelena";
    COUNTRIES["SI"] = "Slovenia";
    COUNTRIES["SJ"] = "Svalbard And JanMayen";
    COUNTRIES["SK"] = "Slovakia";
    COUNTRIES["SL"] = "Sierra Leone";
    COUNTRIES["SM"] = "San Marino";
    COUNTRIES["SN"] = "Senegal";
    COUNTRIES["SO"] = "Somalia";
    COUNTRIES["SR"] = "Suriname";
    COUNTRIES["SS"] = "SouthSudan";
    COUNTRIES["ST"] = "Sao Tome And Principe";
    COUNTRIES["SV"] = "El Salvador";
    COUNTRIES["SX"] = "Sint Maarten";
    COUNTRIES["SY"] = "Syrian Arab Republic";
    COUNTRIES["SZ"] = "Swaziland";
    COUNTRIES["TC"] = "Turks And Caicos Islands";
    COUNTRIES["TD"] = "Chad";
    COUNTRIES["TF"] = "French Southern Territories";
    COUNTRIES["TG"] = "Togo";
    COUNTRIES["TH"] = "Thailand";
    COUNTRIES["TJ"] = "Tajikistan";
    COUNTRIES["TK"] = "Tokelau";
    COUNTRIES["TL"] = "TimorLeste";
    COUNTRIES["TM"] = "Turkmenistan";
    COUNTRIES["TN"] = "Tunisia";
    COUNTRIES["TO"] = "Tonga";
    COUNTRIES["TR"] = "Turkey";
    COUNTRIES["TT"] = "Trinidad And Tobago";
    COUNTRIES["TV"] = "Tuvalu";
    COUNTRIES["TW"] = "Taiwan";
    COUNTRIES["TZ"] = "Tanzania";
    COUNTRIES["UA"] = "Ukraine";
    COUNTRIES["UG"] = "Uganda";
    COUNTRIES["UM"] = "United States Outlying Islands";
    COUNTRIES["US"] = "United States";
    COUNTRIES["UY"] = "Uruguay";
    COUNTRIES["UZ"] = "Uzbekistan";
    COUNTRIES["VA"] = "Holy See Vatican City State";
    COUNTRIES["VC"] = "Saint Vincent And Grenadines";
    COUNTRIES["VE"] = "Venezuela";
    COUNTRIES["VG"] = "Virgin Islands British";
    COUNTRIES["VI"] = "Virgin Is lands US";
    COUNTRIES["VN"] = "Vietnam";
    COUNTRIES["VU"] = "Vanuatu";
    COUNTRIES["WF"] = "Wallis And Futuna";
    COUNTRIES["WS"] = "Samoa";
    COUNTRIES["YE"] = "Yemen";
    COUNTRIES["YT"] = "Mayotte";
    COUNTRIES["ZA"] = "South Africa";
    COUNTRIES["ZM"] = "Zambia";
    COUNTRIES["ZW"] = "Zimbabwe";
})(COUNTRIES || (COUNTRIES = {}));
export var CANADIAN_PROVINCES;
(function (CANADIAN_PROVINCES) {
    CANADIAN_PROVINCES["AB"] = "Alberta";
    CANADIAN_PROVINCES["BC"] = "British Columbia";
    CANADIAN_PROVINCES["MB"] = "Manitoba";
    CANADIAN_PROVINCES["NB"] = "New Brunswick";
    CANADIAN_PROVINCES["NL"] = "Newfoundland and Labrador";
    CANADIAN_PROVINCES["NT"] = "Northwest Territories";
    CANADIAN_PROVINCES["NS"] = "Nova Scotia";
    CANADIAN_PROVINCES["NU"] = "Nunavut";
    CANADIAN_PROVINCES["ON"] = "Ontario";
    CANADIAN_PROVINCES["PE"] = "Prince Edward Island";
    CANADIAN_PROVINCES["QC"] = "Qu\u00E9bec";
    CANADIAN_PROVINCES["SK"] = "Saskatchewan";
    CANADIAN_PROVINCES["YT"] = "Yukon";
})(CANADIAN_PROVINCES || (CANADIAN_PROVINCES = {}));
export var US_STATES;
(function (US_STATES) {
    US_STATES["AL"] = "Alabama";
    US_STATES["AK"] = "Alaska";
    US_STATES["AS"] = "American Samoa";
    US_STATES["AZ"] = "Arizona";
    US_STATES["AR"] = "Arkansas";
    US_STATES["CA"] = "California";
    US_STATES["CO"] = "Colorado";
    US_STATES["CT"] = "Connecticut";
    US_STATES["DE"] = "Delaware";
    US_STATES["DC"] = "District Of Columbia";
    US_STATES["FM"] = "Federated States Of Micronesia";
    US_STATES["FL"] = "Florida";
    US_STATES["GA"] = "Georgia";
    US_STATES["GU"] = "Guam";
    US_STATES["HI"] = "Hawaii";
    US_STATES["ID"] = "Idaho";
    US_STATES["IL"] = "Illinois";
    US_STATES["IN"] = "Indiana";
    US_STATES["IA"] = "Iowa";
    US_STATES["KS"] = "Kansas";
    US_STATES["KY"] = "Kentucky";
    US_STATES["LA"] = "Louisiana";
    US_STATES["ME"] = "Maine";
    US_STATES["MH"] = "Marshall Islands";
    US_STATES["MD"] = "Maryland";
    US_STATES["MA"] = "Massachusetts";
    US_STATES["MI"] = "Michigan";
    US_STATES["MN"] = "Minnesota";
    US_STATES["MS"] = "Mississippi";
    US_STATES["MO"] = "Missouri";
    US_STATES["MT"] = "Montana";
    US_STATES["NE"] = "Nebraska";
    US_STATES["NV"] = "Nevada";
    US_STATES["NH"] = "New Hampshire";
    US_STATES["NJ"] = "New Jersey";
    US_STATES["NM"] = "New Mexico";
    US_STATES["NY"] = "New York";
    US_STATES["NC"] = "North Carolina";
    US_STATES["ND"] = "North Dakota";
    US_STATES["MP"] = "Northern Mariana Islands";
    US_STATES["OH"] = "Ohio";
    US_STATES["OK"] = "Oklahoma";
    US_STATES["OR"] = "Oregon";
    US_STATES["PW"] = "Palau";
    US_STATES["PA"] = "Pennsylvania";
    US_STATES["PR"] = "Puerto Rico";
    US_STATES["RI"] = "Rhode Island";
    US_STATES["SC"] = "South Carolina";
    US_STATES["SD"] = "South Dakota";
    US_STATES["TN"] = "Tennessee";
    US_STATES["TX"] = "Texas";
    US_STATES["UT"] = "Utah";
    US_STATES["VT"] = "Vermont";
    US_STATES["VI"] = "Virgin Islands";
    US_STATES["VA"] = "Virginia";
    US_STATES["WA"] = "Washington";
    US_STATES["WV"] = "West Virginia";
    US_STATES["WI"] = "Wisconsin";
    US_STATES["WY"] = "Wyoming";
})(US_STATES || (US_STATES = {}));
//# sourceMappingURL=Geography.js.map